module.exports = __webpack_public_path__ + "img/frame.0ac0377d.svg";